import {
  getLockValue,
  getSettingsDataInstance,
  getShadowFabricInstance,
  sortBySufix,
  unFocusObjects
} from '@frontend/utils';
import { ADDITIONAL_CIRCLE_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { FIELD_TYPE_CIRCLE } from '@frontend/constants/type-fields-of-template';
import { scaleControlsCornerSize } from '@frontend/constants/fabric-constants';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';
import { createGradient } from '@frontend/utils/gradient-helper';
import { getGroupNameByAddFieldId } from "@/common/preview/draw-smart-object";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export function drawAdditionalCircle({ canvas, id }) {
  unFocusObjects();

  canvas.getObjects().forEach(function (o) {
    if (o.id.includes(ADDITIONAL_CIRCLE_PREFIX_ID)) {
      canvas.remove(o);
    }
  });

  const { canvas_data } = getScopePage();

  const settingsTemplate = getSettingsDataInstance(canvas_data[id]._data?.settings_template);
  const additionalCircles = sortBySufix(canvas_data[id].additionalCircles);

  additionalCircles.forEach((field, index) => {
    const fill_color = canvas_data[id]._data[field + '_fill_color'];
    const strokecolor = canvas_data[id]._data[field + '_stroke_color'];
    const offset_x = canvas_data[id]._data[field + '_offset_x'] || '0';
    const offset_y = canvas_data[id]._data[field + '_offset_y'] || '0';
    const radius = parseFloat(canvas_data[id]._data[field + '_radius']) || 150;
    const opacity = parseFloat(canvas_data[id]._data[field + '_opacity']) || 1;
    const thickness = parseFloat(canvas_data[id]._data[field + '_thickness']) || 0;
    const toggleShape =
      canvas_data[id]._data[field + '_toggle_shape'] !== undefined &&
      canvas_data[id]._data[field + '_toggle_shape'] === 'on';
    const visible = canvas_data[id]._data[field + '_visible'] ?? true;

    if (toggleShape !== undefined && !toggleShape) return;

    let x = 0, y = 0;
    const objectId = ADDITIONAL_CIRCLE_PREFIX_ID + index;
    const gradient = canvas_data[id]._data[`${field}_gradient`];
    const fillType = canvas_data[id]._data[`${field}_fill_type`];
    let fieldsOrderReassignedByUser = canvas_data[id]._data.users_fields_order;
    fieldsOrderReassignedByUser = fieldsOrderReassignedByUser ? JSON.parse(canvas_data[id]._data.users_fields_order) : false;
    const order =
      fieldsOrderReassignedByUser ?
        fieldsOrderReassignedByUser.indexOf(objectId) + 1 :
        (parseInt(canvas_data[id]._data[field + '_order']) || 800);
    const scaleX = parseFloat(canvas_data[id]._data[field + '_scaleX']);
    const scaleY = parseFloat(canvas_data[id]._data[field + '_scaleY']);
    const circle = new fabric.Circle({
      id: objectId,
      element_id: field,
      top: y + parseFloat(offset_y),
      left: x + parseFloat(offset_x),
      radius: radius,
      fill: getFillStyle({ fillType, fill_color, gradient }),
      stroke: strokecolor,
      strokeWidth: thickness,
      opacity,
      selectable: true,
      evented: true,
      order,
      name: settingsTemplate.getNameById(objectId, 'Additional Circle ' + (index + 1)),
      link: settingsTemplate.getLinkById(objectId, ''),
      scaleX,
      scaleY,
      fieldType: FIELD_TYPE_CIRCLE,
      shadow: getShadowFabricInstance(id, field),
      locked: getLockValue(id, field),
      visible,
      gradient,
      fillType,
      groupName: getGroupNameByAddFieldId(
        objectId,
        canvas_data[id]
      )
    });

    circle.setControlsVisibility({
      tl: true,
      tr: true,
      br: true,
      bl: true,
      ml: true,
      mt: true,
      mr: true,
      mb: true,
      mtr: true,
    });

    scaleControlsCornerSize(circle);

    canvas.add(circle);
  });

  function getFillStyle({ fillType, fill_color, gradient }) {
    if (!fillType || fillType === 'solid') {
      return fill_color;
    }

    if (fillType === 'gradient' && gradient) {
      try {
        const gradientData = typeof gradient === 'string' ? JSON.parse(gradient) : gradient;
        return createGradient(gradientData);
      } catch (e) {
        console.error('Error parsing gradient:', e);
        return fill_color;
      }
    }

    return fill_color;
  }
}
